import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Fitness-Angular',
    ModuleType: DwModuleType.application,
    ProductVersion: '1.0.11',
    PublishDateTime: '11/03/2026 05:51:07 PM'
}
